// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon.show-hide-pass {
  z-index: 999;
  font-size: 20px;
  position: absolute;
  right: 0;
  bottom: 8px;
}

.padding {
  padding: 0px 100px;
}
@media only screen and (max-width: 900px) {
  .padding {
    padding: 0px 0px;
  }
}

.border-radius {
  border-radius: 15px;
  background-color: white;
  padding: 20px 15px 20px 15px;
  width: 600px;
  height: auto;
  margin: 0 auto;
  margin-top: 5px;
  margin-bottom: 20px;
}
@media only screen and (max-width: 900px) {
  .border-radius {
    width: 100%;
    margin-bottom: 0px;
  }
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  color: black;
  font-size: 24px;
  cursor: pointer;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNldC10YXgta2V5LWZvcm0uY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxZQUFBO0VBQ0EsZUFBQTtFQUNBLGtCQUFBO0VBQ0EsUUFBQTtFQUNBLFdBQUE7QUFDRjs7QUFFQTtFQUNFLGtCQUFBO0FBQ0Y7QUFBRTtFQUZGO0lBR0ksZ0JBQUE7RUFHRjtBQUNGOztBQURBO0VBQ0UsbUJBQUE7RUFDQSx1QkFBQTtFQUNBLDRCQUFBO0VBQ0EsWUFBQTtFQUNBLFlBQUE7RUFDQSxjQUFBO0VBQ0EsZUFBQTtFQUNBLG1CQUFBO0FBSUY7QUFIRTtFQVRGO0lBVUksV0FBQTtJQUNBLGtCQUFBO0VBTUY7QUFDRjs7QUFIQTtFQUNFLGtCQUFBO0VBQ0EsU0FBQTtFQUNBLFdBQUE7RUFDQSxXQUFBO0VBQ0EsWUFBQTtFQUNBLGVBQUE7RUFDQSxlQUFBO0FBTUYiLCJmaWxlIjoic2V0LXRheC1rZXktZm9ybS5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbImlvbi1pY29uLnNob3ctaGlkZS1wYXNzIHtcbiAgei1pbmRleDogOTk5O1xuICBmb250LXNpemU6IDIwcHg7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogOHB4O1xufVxuXG4ucGFkZGluZyB7XG4gIHBhZGRpbmc6IDBweCAxMDBweDtcbiAgQG1lZGlhIG9ubHkgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA5MDBweCkge1xuICAgIHBhZGRpbmc6IDBweCAwcHg7XG4gIH1cbn1cbi5ib3JkZXItcmFkaXVzIHtcbiAgYm9yZGVyLXJhZGl1czogMTVweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7XG4gIHBhZGRpbmc6IDIwcHggMTVweCAyMHB4IDE1cHg7XG4gIHdpZHRoOiA2MDBweDtcbiAgaGVpZ2h0OiBhdXRvO1xuICBtYXJnaW46IDAgYXV0bztcbiAgbWFyZ2luLXRvcDogNXB4O1xuICBtYXJnaW4tYm90dG9tOiAyMHB4O1xuICBAbWVkaWEgb25seSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDkwMHB4KSB7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgbWFyZ2luLWJvdHRvbTogMHB4O1xuICB9XG59XG5cbi5jbG9zZS1idXR0b24ge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMTBweDtcbiAgcmlnaHQ6IDEwcHg7XG4gIHotaW5kZXg6IDEwO1xuICBjb2xvcjogYmxhY2s7XG4gIGZvbnQtc2l6ZTogMjRweDtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/components/shared/set-tax-key-form/set-tax-key-form.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;AACF;AAAE;EAFF;IAGI,gBAAA;EAGF;AACF;;AADA;EACE,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAIF;AAHE;EATF;IAUI,WAAA;IACA,kBAAA;EAMF;AACF;;AAHA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAMF;AACA,4jDAA4jD","sourcesContent":["ion-icon.show-hide-pass {\n  z-index: 999;\n  font-size: 20px;\n  position: absolute;\n  right: 0;\n  bottom: 8px;\n}\n\n.padding {\n  padding: 0px 100px;\n  @media only screen and (max-width: 900px) {\n    padding: 0px 0px;\n  }\n}\n.border-radius {\n  border-radius: 15px;\n  background-color: white;\n  padding: 20px 15px 20px 15px;\n  width: 600px;\n  height: auto;\n  margin: 0 auto;\n  margin-top: 5px;\n  margin-bottom: 20px;\n  @media only screen and (max-width: 900px) {\n    width: 100%;\n    margin-bottom: 0px;\n  }\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 10;\n  color: black;\n  font-size: 24px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
